<template>
  <!-- 版本更新弹框 -->
  <div class="version-update-dialog">
    <!--  -->
     <el-dialog
      title="提示"
      top="30vh"
      :visible="value"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      
      width="248px"
    >
     <div class="main">
      <div class="main-header">
        <!-- <i class="el-icon-close main-close-icon" @click="closeDialog"></i> -->
        <div class="main-close-icon"></div>
      </div>
      <div class="main-text">
        <p class="main-text-title">
          百运网升级啦！
        </p>
        <p class="main-text-info">
          刷新到最新版本，享受更丰富的功能和体验！
        </p>
        
      </div>
      <div class="reload-btn" @click="reloadPage"></div>
     </div>
     </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {}
  },
  components: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    },
    reloadPage() {
      this.closeDialog();
      // 存入版本号
      this.$router.go(0);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../common/css/common";
.version-update-dialog {
  background: transparent;

  & /deep/ .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  & /deep/ .el-dialog__header {
    padding: 0 !important;
    display: none !important;
  }

  & /deep/ .el-dialog__footer {
    padding: 0 !important;
  }

  & /deep/ .el-dialog__body {
    background: transparent;
    padding: 0 !important;
  }

  .main {
    // position: relative;
    width: 248px;
    height: 269px;
    background: url('../../static/img/indexPage/背景@2x.png');
    background-size: 248px 269px;
    box-sizing: border-box;

    

    .main-header {
      display: flex;
      justify-content: flex-end;
      .main-close-icon {
        display: inline-block;
        width: 16px; 
        height: 16px;
        margin: 74px 16px 0 16px;
        font-size: 16px;
        // &:hover {
        //   cursor: pointer;
        //   color: #0046B9;
        // }
      }
    }

    .main-text {
      margin-top: 23px;
      padding: 0 24px;
      box-sizing: border-box;

      .main-text-title {
        font-size: 18px;
        font-family: AlibabaPuHuiTiM;
        color: #333333;
        line-height: 32px;
      }

      .main-text-info {
        margin-top: 4px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
      }
    }

    .reload-btn {
      margin: 12px 8px 2px 8px;
      width: 232px;
      height: 72px;
      cursor: pointer;
      background: url('../../static/img/indexPage/立即刷新-默认@2x.png');
      background-size: 232px 72px;
      box-sizing: border-box;
      transition: background 0.2s;
      &:hover {
        background: url('../../static/img/indexPage/立即刷新-悬停@2x.png');
        background-size: 232px 72px;
      }

      &:active {
        background: url('../../static/img/indexPage/立即刷新-点击@2x.png');
        background-size: 232px 72px;
      }
    }
  }
}

.version-update-dialog /deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;

  .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VersionUpdateDialog.vue